import { Moment } from "moment";
import Logger from "../../common/util/Logger";

const logger = new Logger("asyncPerfLog");

export const asyncPerfLog = (asyncAction: string, start: Moment, end: Moment) => {
    logger.info(`Async action ${asyncAction} took ${end.diff(start, "ms")} ms`);
};
